import React, { useState } from "react";
import IconComponent from "../Icons/IconComponent";
import Loader from "../Loader/Loader";

const ButtonSKA = ({ isDisabled, type, onClick, nameIcon, dimensionIcon, loaderIcon, fill, color, specialStroke, text, reverseIcon }) => {

    /*
    primary
    primary-icon
    secondary
    secondary-icon
    primary-icon-without-text
    round-secondary-icon-without-text
    secondary-icon-border-without-text
    secondary-icon-carbone-without-text
    pink-icon-without-text
    pagination
    primary-icon-green
    round-navMenu
    primary-icon-animated
    */

    const [isAnimating, setIsAnimating] = useState(false);

    const handleClick = () => {
        setIsAnimating(true);
        onClick();

        // Reinitialize animation after 5 seconde for restart it
        setTimeout(() => setIsAnimating(false), 5000);
    };


    return (
        <div style={{
            borderRadius: type.includes("animated") ? "20px" : null,
            overflow: type.includes("animated") ? "hidden" : null
        }}
        >
            <button disabled={isDisabled} className={`button-${type} ${specialStroke ? "special-stroke" : ""} ${isDisabled ? "disabled-button" : ""} ${isAnimating ? "animate" : ""}`} type='button'
                onClick={type.includes("animated") ? handleClick : onClick}
                style={{
                    "cursor": !isDisabled && onClick ? "pointer" : "default",
                    padding: reverseIcon ? "0 16px 0 20px" : "0 20px 0 16px"
                }}>
                {
                    nameIcon && reverseIcon ?
                        <div>
                            {text ? <div style={{
                                fontSize: "14px"
                            }}>{text}</div> : null}
                            {
                                loaderIcon ?
                                    <div style={{ marginLeft: "10px" }}>
                                        <Loader dimensions="20px" color={"var(--primary-base)"}/>
                                    </div>
                                    :
                                    <IconComponent dimensions={dimensionIcon ? dimensionIcon : "24"} nameIcon={nameIcon} fill={fill} color={color ? color : null}/>
                            }
                        </div>
                        :
                        nameIcon ?
                            <div>
                                {
                                    loaderIcon ?
                                        <div style={{ marginRight: "10px" }}>
                                            <Loader dimensions="20px" color={"var(--primary-base)"}/>
                                        </div>
                                        :
                                        <IconComponent dimensions={dimensionIcon ? dimensionIcon : "24"} nameIcon={nameIcon} fill={fill} color={color ? color : null}/>
                                }
                                {text ? <div style={{
                                    fontSize: "14px"
                                }}>{text}</div> : null}
                            </div>
                            :
                            <div>{text ? text : null}</div>
                }
            </button>

        </div>
    );
};

export default ButtonSKA;
